import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getStoredToken } from "../../utils/auth";

const PublicRoute = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Google/Facebook return here with ?success=...; let the login page handle that callback first
  if (params.has("success")) {
    return children;
  }

  if (getStoredToken()) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default PublicRoute;
